import common from '../common'
/**
 *  * 保存图片到手机相册
 */
const saveQRCode = (url) => {
    if( !url ) {
        return
    }
    // 安卓
    if( !common?.isAndroid_ios() ) {
        if (!!window?.androidNative?.saveQRCode) {
            window?.androidNative?.saveQRCode(url)
        }
    }else {
        if( window?.webkit?.messageHandlers?.saveQRCode ) {
            window?.webkit.messageHandlers.saveQRCode.postMessage(url)
        }
    }
}
export default saveQRCode